import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { Button, Modal, SingleSelect, TsDataSource } from "../..";
import { FormTextField } from "../../forms";
import { RSForm } from "../..";
import { addZone } from "../utils";
const BOARD_ENDPOINTS = [
    "board",
    "view",
    "zone",
    "component",
    "view_board",
    "component_zone",
    "zone_view",
];
const MISC_ENDPOINTS = ["user", "user_action", "action", "singular"];
function ZoneModal(props) {
    const { open, setOpen, setZones, zones, zoneOrder, setZoneOrder, ds, viewId, dataUrl, } = props;
    const [objectType, setObjectType] = useState("");
    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState(false);
    const [fieldError, setFieldError] = useState(false);
    const [objectTypesList, setObjectTypesList] = useState([]);
    function reset() {
        setObjectType("");
        setTitle("");
        setTitleError(false);
        setFieldError(false);
    }
    function checkStates() {
        setTitleError(false);
        setFieldError(false);
        let validId = true;
        let validField = true;
        // @ts-ignore
        if (title === "") {
            setTitleError(true);
            validId = false;
        }
        if (objectType === "" || objectType === null) {
            setFieldError(true);
            validField = false;
        }
        return validId && validField;
    }
    useEffect(() => {
        if (!open) {
            reset();
        }
    }, [open]);
    useEffect(() => {
        const tempDs = new TsDataSource({ baseUrl: dataUrl });
        tempDs.attributeMetadata().then((am) => {
            setObjectTypesList(Object.keys(am).filter((key) => ![...BOARD_ENDPOINTS, ...MISC_ENDPOINTS].includes(key)));
        });
    }, []);
    const onAddZone = async () => {
        if (checkStates()) {
            const orders = zoneOrder.map((zone) => {
                return zone.order;
            });
            const nextOrder = orders.length > 0 ? Math.max(...orders) + 1 : 1;
            const newZone = await addZone(ds, objectType, title, nextOrder, viewId, dataUrl);
            setZones([
                ...zones,
                {
                    id: newZone.newZoneId,
                    objectType: objectType,
                    title: title,
                },
            ]);
            setZoneOrder([
                ...zoneOrder,
                {
                    zoneId: newZone.newZoneId,
                    order: nextOrder,
                    zoneViewId: newZone.newZoneViewId,
                },
            ]);
            reset();
            setOpen(false);
        }
    };
    const actionButtons = (_jsxs("div", { children: [_jsx(Button, { position: "right", type: "success", onClick: onAddZone, icon: "plus", text: "Add Zone" }), _jsx(Button, { position: "right", type: "error", onClick: () => setOpen(false), icon: "times", text: "Cancel" })] }));
    return (_jsx("div", { className: "confirm-delete-buttons", children: _jsx(Modal, { open: open, size: "xs", setOpen: setOpen, actionButton: actionButtons, closeButton: false, overflow: false, "data-testid": "zoneModal", children: _jsxs("div", { children: [_jsx("h4", { children: "Add New Zone" }), _jsxs("p", { className: "zone-modal-labels", children: ["Select Object Type ", _jsx("span", { style: { color: "red" }, children: "*" })] }), _jsx(SingleSelect, { data: objectTypesList, placeholder: "Object Type", value: objectType, setValue: setObjectType, block: true }), _jsx("br", {}), _jsxs("p", { className: "zone-modal-labels", children: ["Enter Title ", _jsx("span", { style: { color: "red" }, children: "*" })] }), _jsx(RSForm, { fluid: true, children: _jsx(FormTextField, { id: "zone-title", onChange: (value) => setTitle(value), name: "Zone Title", placeholder: `Zone Title`, label: "" }) }), titleError ? (_jsx("p", { className: "tol-modal-error", children: "Title cannot be blank" })) : null, fieldError ? (_jsx("p", { className: "tol-modal-error", children: "Please ensure all mandatory fields are filled" })) : null] }) }) }));
}
export default ZoneModal;
